import { graphql, useStaticQuery } from "gatsby";

export default function useRestaurants(filter = undefined) {
	const { allRestaurants } = useStaticQuery(graphql`
		query {
			allRestaurants: allMarkdownRemark(
				filter: { frontmatter: { show: { eq: true } } }
				sort: { frontmatter: { order: ASC } }
			) {
				...AllRestaurants
			}
		}

		fragment AllRestaurants on MarkdownRemarkConnection {
			nodes {
				...RestaurantFields
			}
		}

		fragment RestaurantFields on MarkdownRemark {
			fields {
				id
			}
			frontmatter {
				comingSoon
				title {
					es
					en
				}
				description {
					es
					en
				}
				location {
					es
					en
				}
				stamp
				locationJp
				hours
				booking
				bookingGroup
				bookingGroupMin
				bookingPhone
				bookingDisabledText {
					es
					en
				}
				address
				gMapsLink
				cartaAPIKey
				gallery {
					description {
						en
						es
					}
					slides {
						title {
							en
							es
						}
						titleJp
						image
						text {
							en
							es
						}
					}
				}
				features {
					title {
						en
						es
					}
					titleJp
					image
					text {
						en
						es
					}
				}
			}
		}
	`);

	if (filter) {
		return allRestaurants?.nodes.filter(filter);
	}
	return allRestaurants?.nodes;
}
